import { action } from 'satcheljs';
import { MailboxInfo } from 'owa-client-ids';

export const updateInitialParameters = action(
    'updateInitialParameters',
    (mailboxInfo: MailboxInfo) => ({
        mailboxInfo: mailboxInfo,
    })
);
